import { render, staticRenderFns } from "./activeList.vue?vue&type=template&id=7171b2e5&scoped=true"
import script from "./activeList.vue?vue&type=script&lang=js"
export * from "./activeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7171b2e5",
  null
  
)

export default component.exports